<template>
<div>
    <div class="p-6 my-4 bg-white border border-gray-200 my-rounded">
        <div class="items-center justify-between md:flex" v-if="!isOpen">
            <div>
                <div class="text-xs font-light">{{address.prenom + ' ' + address.nom}}</div>
                <div test-id="address-value" class="text-lg font-bold">{{address.fullAddress.fullAddress}}</div>
            </div>
            <div class="mt-2 md:mt-0">
                <button @click="isOpen = true" class="px-3 py-2 text-sm font-light text-gray-700 duration-200 bg-gray-200 border-gray-200 rounded hover:bg-gray-300" test-id="address-btn-update"> {{$t('parametres.mes-adresses.modifier')}} </button>
                <button @click="deleteAddress" class="px-3 py-2 text-sm font-light duration-200 bg-red-200 border-red-200 rounded hover:bg-red-300" test-id="address-btn-delete"> {{$t('parametres.mes-adresses.supprimer')}} </button>
            </div>
        </div>
        <div v-if="isOpen">
            <div class="text-right">
                <button @click="isOpen = false" class="px-3 py-2 text-sm font-light text-gray-700 text-red-500 duration-200 bg-gray-200 border-gray-200 rounded hover:bg-gray-300">
                    <i class="fas fa-times"></i>
                </button>
            </div>
            <template v-if="!isOpen">{{addressInput}}</template>
            <sav-map-input v-model="newAddress" @input="updateAddress" :default="addressInput" :nom="address.nom" :prenom="address.prenom" :map="false" />
        </div>
    </div>
</div>
</template>

<script>
import apiService from '@/services/api.service'
import eventHub from '@/eventHub'

export default {
    props: {
        user: {
            type: Object,
            required: true
        },
        address: {
            type: Object,
            required: true
        }
    },
    watch: {
        address: function(value) {
            this.addressInput = value.fullAddress.fullAddress
        }
    },
    data() {
        return {
            isOpen: false,
            addressInput: null,
            newAddress: null
        }
    },
    methods: {
        async updateAddress() {
            this.isOpen = false
            let address = this.newAddress
            let response = await apiService.post('updateadresse', {
                id_adresse: this.address.id,
                id_conso: this.user.id,
                nom: address.nom,
                prenom: address.prenom,
                adresse1: address.adresse1,
                adresse2: address.adresse2,
                cp: address.cp,
                ville: address.ville,
                longitude: address.longitude,
                latitude: address.latitude
            })

            eventHub.$emit('refresh-user')
        },

        async deleteAddress() {
            let response = await apiService.post('deleteadresse', {
                id_adresse: this.address.id
            })
            eventHub.$emit('refresh-user')
        },
    },
    mounted() {
        this.addressInput = this.address.fullAddress.fullAddress
    }
}
</script>



// WEBPACK FOOTER //
// src/companies/default/views/user/components/AddressUpdateCard.vue